module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /Users/leedongwei/Documents/Projects/crimp-application/node_modules/core-js/library/modules/_add-to-unscopables.js
// module id = 456
// module chunks = 0